export const requestResetPassord = {
  title: 'Esqueci minha senha',
  subtitle:
    'Informe seu e-mail para seguir com o processo de alteração de senha.',
};
